import React, { useState, useEffect } from 'react';
import { getLogs } from '../../services/api';
import './Logs.css';

const Logs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState({
    level: '',
    tipo: '',
    patente: ''
  });

  useEffect(() => {
    fetchLogs();
  }, [page, filters]);

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const params = {
        page,
        page_size: 20
      };
      if (filters.level) params.level = filters.level;
      if (filters.tipo) params.tipo = filters.tipo;
      if (filters.patente) params.patente = filters.patente;

      const data = await getLogs(params);
      setLogs(data.items);
      setTotalPages(data.total_pages);
    } catch (err) {
      setError('Error al cargar logs');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
    setPage(1);
  };

  const getLevelBadgeClass = (level) => {
    switch (level) {
      case 'ERROR': return 'badge-error';
      case 'WARNING': return 'badge-warning';
      case 'INFO': return 'badge-info';
      case 'DEBUG': return 'badge-debug';
      default: return 'badge-default';
    }
  };

  const getTipoBadgeClass = (tipo) => {
    switch (tipo) {
      case 'CONSULTA': return 'badge-consulta';
      case 'AUTH': return 'badge-auth';
      case 'CAPTCHA': return 'badge-captcha';
      case 'SISTEMA': return 'badge-sistema';
      default: return 'badge-default';
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString('es-AR');
  };

  return (
    <div className="logs-page">
      <h1 className="logs-title">Logs del Sistema</h1>

      <div className="logs-filters">
        <div className="filter-group">
          <label>Nivel</label>
          <select name="level" value={filters.level} onChange={handleFilterChange}>
            <option value="">Todos</option>
            <option value="DEBUG">DEBUG</option>
            <option value="INFO">INFO</option>
            <option value="WARNING">WARNING</option>
            <option value="ERROR">ERROR</option>
          </select>
        </div>
        <div className="filter-group">
          <label>Tipo</label>
          <select name="tipo" value={filters.tipo} onChange={handleFilterChange}>
            <option value="">Todos</option>
            <option value="CONSULTA">CONSULTA</option>
            <option value="AUTH">AUTH</option>
            <option value="CAPTCHA">CAPTCHA</option>
            <option value="SISTEMA">SISTEMA</option>
          </select>
        </div>
        <div className="filter-group">
          <label>Patente</label>
          <input
            type="text"
            name="patente"
            value={filters.patente}
            onChange={handleFilterChange}
            placeholder="Buscar patente..."
          />
        </div>
      </div>

      {loading ? (
        <div className="logs-loading">Cargando logs...</div>
      ) : error ? (
        <div className="logs-error">{error}</div>
      ) : (
        <>
          <div className="logs-table-container">
            <table className="logs-table">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Nivel</th>
                  <th>Tipo</th>
                  <th>Mensaje</th>
                  <th>Patente</th>
                  <th>IP</th>
                </tr>
              </thead>
              <tbody>
                {logs.length > 0 ? (
                  logs.map(log => (
                    <tr key={log.id}>
                      <td className="td-date">{formatDate(log.timestamp)}</td>
                      <td>
                        <span className={`badge ${getLevelBadgeClass(log.level)}`}>
                          {log.level}
                        </span>
                      </td>
                      <td>
                        <span className={`badge ${getTipoBadgeClass(log.tipo)}`}>
                          {log.tipo}
                        </span>
                      </td>
                      <td className="td-mensaje">{log.mensaje}</td>
                      <td>{log.patente || '-'}</td>
                      <td>{log.ip_origen || '-'}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="no-data">No hay logs disponibles</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {totalPages > 1 && (
            <div className="pagination">
              <button
                onClick={() => setPage(p => Math.max(1, p - 1))}
                disabled={page === 1}
              >
                Anterior
              </button>
              <span className="page-info">
                Pagina {page} de {totalPages}
              </span>
              <button
                onClick={() => setPage(p => Math.min(totalPages, p + 1))}
                disabled={page === totalPages}
              >
                Siguiente
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Logs;
